import { ModelID, SearchParams, Service } from '@/types';

export type Filter = 'all' | 'active' | 'inactive';
export type Sort = 'created_at' | 'updated_at' | 'service_id' | 'asset_type_id';
export interface ServiceSearchParams extends SearchParams<Filter, Sort>, Partial<Service> {}

export const featurePath = '/v4/location/service';

export const featureKeys = {
  all: [{ scope: 'services' }] as const,

  lists: (location: ModelID) => [{ ...featureKeys.all[0], location, entity: 'list' }] as const,

  list: (location: ModelID, search: ServiceSearchParams = {}) =>
    [{ ...featureKeys.lists(location)[0], search }] as const,

  details: () => [{ ...featureKeys.all[0], entity: 'detail' }] as const,

  detail: (id: ModelID) => [{ ...featureKeys.details()[0], id }] as const,
};
